import { render, staticRenderFns } from "./videoInfo.vue?vue&type=template&id=ef376ac2&scoped=true"
import script from "./videoInfo.vue?vue&type=script&lang=js"
export * from "./videoInfo.vue?vue&type=script&lang=js"
import style0 from "./videoInfo.vue?vue&type=style&index=0&id=ef376ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef376ac2",
  null
  
)

export default component.exports